import { render, staticRenderFns } from "./App.vue?vue&type=template&id=6ac38c62&scoped=true&"
import script from "./App.vue?vue&type=script&lang=ts&setup=true&"
export * from "./App.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./App.vue?vue&type=style&index=0&id=6ac38c62&prod&scoped=true&lang=scss&"
import style1 from "./App.vue?vue&type=style&index=1&id=6ac38c62&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ac38c62",
  null
  
)

export default component.exports